export default __webpack_public_path__ + "static/media/1941.c0c41787.png";